import Cookies from 'cookies-js'
import { push } from 'react-router-redux'
import { userInfoLoad } from './userinfo'
import { createReducer } from './reducerUtils'
import { map } from 'rxjs/operators'
import { ofType } from 'redux-observable'

const oidcAuthTokenPath = `daptiv.oidcauthtoken.${daptiv.ptb.WebConfig.env}`

// Actions
export const TOKEN_UPDATE = 'TOKEN_UPDATE'
export const TOKEN_REVOKE = 'TOKEN_REVOKE'
export const TOKEN_LOAD = 'TOKEN_LOAD'
export const RETURN_PATH_UPDATE = 'UPDATE_RETURN_PATH'

// Action Creators
export const returnPathUpdate = path => ({ type: RETURN_PATH_UPDATE, payload: path })
export const tokenLoad = () => ({ type: TOKEN_LOAD })
export const tokenUpdate = token => ({ type: TOKEN_UPDATE, payload: token })
export const tokenRevoke = () => ({ type: TOKEN_REVOKE })

// Epics
export const tokenRevokeEpic = action$ =>
  action$.pipe(
    ofType(TOKEN_REVOKE),
    map(action => {
      Cookies.expire(oidcAuthTokenPath)
      return push('/login')
    })
  )

export const tokenLoadEpic = action$ =>
  action$.pipe(
    ofType(TOKEN_LOAD),
    map(action => {
      let oidcauthtoken = Cookies.get(oidcAuthTokenPath)
      return oidcauthtoken
        ? tokenUpdate(JSON.parse(atob(oidcauthtoken)).accessToken)
        : tokenRevoke()
    })
  )

export const tokenUpdateEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(TOKEN_UPDATE),
    map(action => {
      vapiClient.setAuthToken(action.payload)
      return userInfoLoad()
    })
  )

// Reducer
const returnPathUpdateReducer = (state, returnPath) => ({ ...state, returnPath })
const tokenUpdateReducer = (state, token) => ({ ...state, token })
const tokenRevokeReducer = (state) => ({ ...state, token: null })

const authorizationHandlerMapping = {
  [RETURN_PATH_UPDATE]: returnPathUpdateReducer,
  [TOKEN_UPDATE]: tokenUpdateReducer,
  [TOKEN_REVOKE]: tokenRevokeReducer
}

const authorizationInitialState = {}
export const authorizationReducer = createReducer(authorizationInitialState, authorizationHandlerMapping)

export default authorizationReducer



// WEBPACK FOOTER //
// ./src/store/authorization.js